module.exports = __webpack_public_path__ + "img/slide_7.6dcfb09d.png";